import { AlaFormulario, AlaIdiomaFormulario } from './../domain/AlaFormulario';
import { Component, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { TranslateService } from 'ng2-translate';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { Idioma } from '../domain/Idioma';
import { IdiomaService } from '../providers/idioma/idioma.service';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';
import { AppComponent } from '../app.component';
import { HashLocationStrategy } from '@angular/common';


@Component({
	selector: 'app-formulario-ala',
	templateUrl: './FormularioAla.component.html',
    providers: [MessageService]
})

export class FormularioAlaComponent implements OnDestroy, OnChanges{ // extends FormGroup { // extends FormularioBaseComponent<ALA> {

	// Nivel al que pertenece el Ala
	@Input() nivelSeleccionado: any = {};
	@Input() alaSeleccionada: AlaFormulario = new AlaFormulario();
	@Input() edicion: boolean;
	// Imagen seleccionada en el selector de imagen
	@Input() imagenAlaSeleccionada: any;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	msgs: Message[] = [];
	public confirmacionVisible = false;
	public operacion = '';
	public labelBotonImagen = 'Seleccionar Plano';

	public fAltaError = false;
	public fBajaError = false;
	public zoomMaxError = false;
	public zoomMaxRutaError = false;
	public zoomMinError = false;
	public zoomMinLabelError = false;
	public zoomOkError= false;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	// Componente selector de la Imagen
	selectorImagenAla: any;

	escalaNodos;
	escalaContenidos;

	spinner: HTMLElement;
	geoposicionar: boolean;

	constructor(
		private appComponent: AppComponent,
		private entityManager: EntityManagerProvider,
		private wsServices: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private idiomaService: IdiomaService,
		private translate: TranslateService)
	{
		const that = this;
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
		});

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.geoposicionar = false;
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.msgs = [];
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
		this.confirmacionVisible = false;
		this.escalaNodos = this.alaSeleccionada.IconoNodoScale * 10;
		this.escalaContenidos = this.alaSeleccionada.IconoContenidoScale * 10;
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	/* ** Metodos de GroupForm ** */
	onFileSelectAla($event, fileUploadComponentAla) {
		// this.labelBotonImagen = 'Cambiar Plano';
		this.selectorImagenAla = fileUploadComponentAla;
		console.log('$event.files[0] = ' + $event.files[0]);
		this.imagenAlaSeleccionada = $event.files[0];
		// this.alaSeleccionada.Imagen = $event.files[0];
	}

	onRemoveSelect($event?, fileUploadComponent?) {
		// this.labelBotonImagen = 'Añadir Plano';
		this.imagenAlaSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
		// this.labelBotonImagen = 'Añadir Plano';
		this.onRemoveSelect();
	}

	onBase64Generated(img) {
		this.imagenAlaSeleccionada = img;
		console.log('this.imagenAlaSeleccionada = ' + this.imagenAlaSeleccionada);
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/*  */
	inputChanged(value) {
		//  Cojemos la traduccion del espacio al idioma seleccionado
		const alaIdioma = this.alaSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		alaIdioma.Nombre = this.alaSeleccionada.Nomobre;
		alaIdioma.Descripcion = this.alaSeleccionada.Descripcion;
		this.alaSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, alaIdioma);

		this.fAltaError = this.alaSeleccionada.FechaAlta === undefined || this.alaSeleccionada.FechaAlta === null || this.alaSeleccionada.FechaAlta.toString() === '';
		this.fBajaError = false; // this.rutaSeleccionada.FechaBaja === ''  || this.rutaSeleccionada.FechaBaja === undefined  || this.rutaSeleccionada.FechaBaja === null
		this.zoomMinError = this.alaSeleccionada.zoomMinimo <= 0;
		this.zoomMaxError = this.alaSeleccionada.zoomMaximo <= 0;
		this.zoomMaxRutaError = this.alaSeleccionada.zoomMaximoRuta <= 0;
		this.zoomMinLabelError = this.alaSeleccionada.zoomMinimoLabel <= 0;
		this.zoomOkError = this.alaSeleccionada.zoomMaximo <  this.alaSeleccionada.zoomMinimo;
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'Desde') {
			this.alaSeleccionada.FechaAlta = fecha;
		}
		if (tipo === 'Hasta') {
			this.alaSeleccionada.FechaBaja = fecha;
		}
		this.inputChanged(fecha);
		calendar.overlayVisible=false;
	}

	public esEdicion(): boolean {
		return this.edicion;
	}

	public validar(): boolean {

		this.inputChanged('');

		if (this.zoomOkError) {
			this.appComponent.showError('El zoom Minimo ha de ser menos al zoom Maximo');
			this.spinner.style.display = 'none';
			return !this.zoomOkError;
		}
		const ok = !this.fAltaError && !this.zoomMaxError && !this.zoomMaxRutaError && !this.zoomMinError && !this.zoomMinLabelError;

		if (!ok){
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			this.spinner.style.display = 'none';
		}

		return ok;
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.msgs = [];
		this.spinner.style.display = 'inherit';
		if (this.operacion === 'guardar') {
			this.guardar();
		}
		else if (this.operacion === 'eliminar'){
			this.eliminar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}


	/* Operaciones */
	public guardar(): any {
		if (this.validar()) {
			if (!this.esEdicion()) {
				this.guardarNuevo();
			}
			else {
				this.guardarEdicion();
			}
		} else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}

	public subirImagenAlaSeleccionada(imagenAlaSeleccionada) {
		if (imagenAlaSeleccionada) {
			// return this.wsServices.subirFicheroCMS(imagenAlaSeleccionada, 'imagenAlaSeleccionada.png').toPromise();
			return this.wsServices.subirFicheroCMS(imagenAlaSeleccionada).toPromise();
		}
		else {
			return Promise.resolve('done');
		}
	}

	public guardarNuevo() {
		const that = this;

		let urlImagenAlaSeleccionada = '';

		this.subirImagenAlaSeleccionada(this.imagenAlaSeleccionada)
		.then(function(urlImagen) {
			console.log(urlImagen)
			urlImagenAlaSeleccionada = urlImagen;
			return that.entityManager.newALA();
		})
		.then(function(oALA) {
			oALA.IDIOMAS.forEach(ALA_IDIOMA => {
				const aux = that.alaSeleccionada.Idiomas.get(ALA_IDIOMA.IDIOMA.Codigo);

				if(aux){
					ALA_IDIOMA.Nombre = aux.Nombre;
					ALA_IDIOMA.Descripcion = aux.Descripcion;
				}
				else{
					const espacioIdioma = that.alaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
					if(espacioIdioma){
						ALA_IDIOMA.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
						ALA_IDIOMA.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';
					}
				}

			});

			const alaIdioma = that.alaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.alaSeleccionada.Nomobre = alaIdioma ? alaIdioma.Nombre : '';
			that.alaSeleccionada.Descripcion = alaIdioma ? alaIdioma.Descripcion : '';

			oALA.Nomobre = that.alaSeleccionada.Nomobre;
			oALA.Descripcion = that.alaSeleccionada.Descripcion;

			oALA.zoomMinimo = that.alaSeleccionada.zoomMinimo;
			oALA.zoomMaximo = that.alaSeleccionada.zoomMaximo;
			oALA.zoomMaximoRuta = that.alaSeleccionada.zoomMaximoRuta;
			oALA.zoomMinimoLabel = that.alaSeleccionada.zoomMinimoLabel;

			oALA.FechaAlta = that.alaSeleccionada.FechaAlta;
			oALA.FechaBaja = that.alaSeleccionada.FechaBaja;

			oALA.IconoContenidoScale = that.escalaContenidos / 10;
			oALA.IconoNodoScale = that.escalaNodos / 10;

			oALA.ConexionScale = 1;
			oALA.AristaSeccionScale = 1;
			oALA.PuntosConexionScale = 1;
			oALA.PuntosSeccionScale = 1;

			oALA.RutaImagen = urlImagenAlaSeleccionada;
			oALA.backgroundColor = that.alaSeleccionada.backgroundColor;

			that.alaSeleccionada.ENTIDAD = oALA;

			// that.alaSeleccionada = that.alaSeleccionada = oALA;
			that.nivelSeleccionado.ALAS.push(oALA);

			return that.entityManager.newSECCION();
		})
		.then(function (oSECCION: any) {
			oSECCION.Nombre = 'Default';
			oSECCION.Descripcion = 'Default para Ala: ' + that.alaSeleccionada.Nomobre;
			oSECCION.FechaAlta = new Date();
			oSECCION.IdAla = that.alaSeleccionada.ENTIDAD.Id;
			oSECCION.IDIOMAS.forEach(element => {
				element.Nombre = 'Default';
				element.Descripcion = 'Default para Ala: ' + that.alaSeleccionada.Nomobre;
			});
			
			that.alaSeleccionada.ENTIDAD.SECCIONS.push(oSECCION);

			return that.entityManager.saveChanges();
		})
		.then(function (elem: any) {
			console.log(elem)
			if (elem !== false) {
				that.onElementoGuardado.emit(elem);
				return elem;
			}
			else {
				that.onElementoError.emit(elem);
				return elem;
			}
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})


		.catch(function (e) {
			that.spinner.style.display = 'none';
			return false;
		});
	}

	public guardarEdicion() {
		const that = this;

		return this.guardarMultiIdioma()
		.then(function () {

			const espacioIdioma = that.alaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.alaSeleccionada.Nomobre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			that.alaSeleccionada.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

			that.alaSeleccionada.ENTIDAD.Nomobre = that.alaSeleccionada.Nomobre;
			that.alaSeleccionada.ENTIDAD.Descripcion = that.alaSeleccionada.Descripcion;

			that.alaSeleccionada.ENTIDAD.zoomMinimo = that.alaSeleccionada.zoomMinimo;
			that.alaSeleccionada.ENTIDAD.zoomMaximo = that.alaSeleccionada.zoomMaximo;
			that.alaSeleccionada.ENTIDAD.zoomMaximoRuta = that.alaSeleccionada.zoomMaximoRuta;
			that.alaSeleccionada.ENTIDAD.zoomMinimoLabel = that.alaSeleccionada.zoomMinimoLabel;

			that.alaSeleccionada.ENTIDAD.IconoContenidoScale = that.escalaContenidos / 10;
			that.alaSeleccionada.ENTIDAD.IconoNodoScale = that.escalaNodos / 10;

			that.alaSeleccionada.ENTIDAD.FechaAlta = that.alaSeleccionada.FechaAlta;
			that.alaSeleccionada.ENTIDAD.FechaBaja = that.alaSeleccionada.FechaBaja;
			that.alaSeleccionada.ENTIDAD.backgroundColor = that.alaSeleccionada.backgroundColor;

			if (that.imagenAlaSeleccionada){
				console.log('guardarEdicion = ' + that.imagenAlaSeleccionada);
				that.subirImagenAlaSeleccionada(that.imagenAlaSeleccionada)
				.then(function(urlImagen) {
					that.alaSeleccionada.ENTIDAD.RutaImagen = urlImagen;

					return that.entityManager.saveChanges();
				})
				.then(function (msg) {
					that.onElementoGuardado.emit(that.alaSeleccionada);
					return msg;
				})
				.then(function(data: any) {
					console.log(data)
					// Renovamos el Token
					if(data.httpResponse.status === 200){
						that.authService.relogin();
					}
				})
				.catch(function (err) {
					return err;
				});
			}
			else{
				that.entityManager.saveChanges()
				.then(function (msg) {
					that.onElementoGuardado.emit(that.alaSeleccionada);
					return msg;
				})
				.then(function(data: any) {
					console.log(data)
					// Renovamos el Token
					if(data.httpResponse.status === 200){
						that.authService.relogin();
					}
				})
				.catch(function (err) {
					that.spinner.style.display = 'none';
					return err;
				});
			}
		});

	}

	public eliminar() {
		const that = this;
		this.eliminarSeleccionado()
			.then(function () {
				that.onElementoEliminado.emit(that.alaSeleccionada.ENTIDAD);
				// Renovamos el Token
				that.authService.relogin();
			})
			.catch(function (e) {
				that.onElementoEliminado.emit(false);
				console.log(e);
				return e;
			});
	}

	public eliminarSeleccionado() {
		const that = this;
		if (this.alaSeleccionada !== undefined) {
			return this.entityManager.deleteALA(this.alaSeleccionada.ENTIDAD)
			.then(function(){

				return true;
			});
			// return this.entityManager.saveChanges();
		}
	}

	/* App-Selector_Idioma */
	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let alaIdioma = this.alaSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!alaIdioma) {
			alaIdioma = new AlaIdiomaFormulario();
			this.alaSeleccionada.Idiomas.set(idioma.value, alaIdioma);
		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.alaSeleccionada.Nomobre = alaIdioma.Nombre;
		this.alaSeleccionada.Descripcion = alaIdioma.Descripcion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.alaSeleccionada.ENTIDAD.IDIOMAS);

		return this.entityManager.newALA_IDIOMA(this.alaSeleccionada.ENTIDAD)
		.then(function(ALA_IDIOMAs){

			ALA_IDIOMAs.forEach(ALA_IDIOMA => {
				const aux = that.alaSeleccionada.Idiomas.get(ALA_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					ALA_IDIOMA.Nombre = aux.Nombre;
					ALA_IDIOMA.Descripcion = aux.Descripcion;
				}
			});
		});
	}

	posicionarAla(){
		this.geoposicionar = true;
		//this.appComponent.showError('No Implementado!');
	}


	onEscalaContenidoChange(event){
		console.log(event.value / 10);
	}

	onEscalaNodoChange(event){
		console.log(event.value / 10);
	}

		/* PIPETA */
	/*
		seleccionPipeta(){
			this.setEyedropSelected(true);
		}
	*/
	public onColorChange($event){
		console.log($event);
	}

	public getColor(){
		return this.alaSeleccionada.backgroundColor;
	}

	public setColor(_color){

		const colors = _color.match(/\d+/g);
		let  alfa = '1';
		if ( colors.length < 3 )	{
			return;
		}

		if (colors[3] !== undefined){
			alfa = colors[3] + (colors[4] !== undefined ? '.' + colors[4] : '' );
		}

		_color = 'rgba(' + colors[0] + ',' + colors[1] + ',' + colors[2] + ',' + alfa + ')';

		this.alaSeleccionada.backgroundColor = _color;
	}

	mostrarMiniaturaAla(){
		const hayNuevaImagenSeleccionada = this.imagenAlaSeleccionada !== undefined;
		const mostrar = this.alaSeleccionada.Imagen && this.alaSeleccionada.Imagen !== 'done'  && !hayNuevaImagenSeleccionada;
		return mostrar;
	}

	mostrarMiniaturaNoHayImagen(){
		const hayNuevaImagenSeleccionada = this.imagenAlaSeleccionada !== undefined;
		const mostrar = !this.mostrarMiniaturaAla() && !hayNuevaImagenSeleccionada;
		return mostrar;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioAla.component.ts